import type { CSSProperties } from "react";

export type ProductSliderScrollBottomCtaAlign = "left" | "center" | "right";
export type ProductSliderScrollBottomCtaVariant = "primary" | "secondary" | "outline";

type ProductSliderScrollBottomCtaVariantToken = {
  button: CSSProperties;
};

export const productSliderScrollBottomCtaAlignTokens: Record<
  ProductSliderScrollBottomCtaAlign,
  CSSProperties["justifyContent"]
> = {
  left: "flex-start",
  center: "center",
  right: "flex-end",
};

export const productSliderScrollBottomCtaVariantTokens: Record<
  ProductSliderScrollBottomCtaVariant,
  ProductSliderScrollBottomCtaVariantToken
> = {
  primary: {
    button: {
      background: "#111111",
      borderColor: "#111111",
      color: "#ffffff",
    },
  },
  secondary: {
    button: {
      background: "#f4f1ec",
      borderColor: "#f4f1ec",
      color: "#111111",
    },
  },
  outline: {
    button: {
      background: "transparent",
      borderColor: "rgba(17, 17, 17, 0.28)",
      color: "#111111",
    },
  },
};
